export default __webpack_public_path__ + "static/media/placeholder_store04-fr-mobile.f0b06cc2.png";